import { SelectionTemplateTaintEffect } from '@cast/types';
import { KubernetesTaintEffectEnum } from '@cast/types-omni';

export const OMNI_TAINT_EFFECT_BY_TEMPLATE_TAINT_EFFECT: Record<
  SelectionTemplateTaintEffect,
  KubernetesTaintEffectEnum
> = {
  [SelectionTemplateTaintEffect.NoSchedule]:
    KubernetesTaintEffectEnum.NO_SCHEDULE,
  [SelectionTemplateTaintEffect.NoExecute]:
    KubernetesTaintEffectEnum.NO_EXECUTE,
};
